import { call, put, takeEvery } from "redux-saga/effects"

import { GET_FEATURES, ADD_NEW_FEATURE, UPDATE_FEATURE, DELETE_FEATURE } from "./actionTypes";
import {
    getFeaturesSuccess,
    getFeaturesFail,
    addFeatureSuccess,
    addFeatureFail,
    updateFeatureSuccess,
    updateFeatureFail,
    deleteFeatureSuccess,
    deleteFeatureFail,
   
} from "./actions"

import {
    getFeatures,
    addNewFeature,
    updateFeature,
    deleteFeature,
   
} from "helpers/features/features_backend_helper";
import { toast } from "react-toastify";

function* fetchFeatures() {
    try {
        const response = yield call(getFeatures)
        yield put(getFeaturesSuccess(response))
    } catch (error) {
        yield put(getFeaturesFail(error))
    }
}

function* onAddNewFeature({ payload: data }) {
    try {
        const response = yield call(addNewFeature, data)

       
        yield put(addFeatureSuccess(response.feature))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(addFeatureFail(error))
        const errorMessage = error.response?.data?.error
        toast.error(errorMessage, { autoClose: 2000 });
    }
}

function* onUpdateFeature({ payload: data }) {
    try {

        console.log("ON UPDATE: ", data);
        const response = yield call(updateFeature, data)
        yield put(updateFeatureSuccess(response.feature))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateFeatureFail(error))
        const errorMessage = error.response?.data?.error
        toast.error(errorMessage, { autoClose: 2000 });
    }
}

function* onDeleteFeature({ payload: data }) {

    try {
        const response = yield call(deleteFeature, data)
        yield put(deleteFeatureSuccess(response))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteFeatureFail(error))
        const errorMessage = error.response?.data?.error
        toast.error(errorMessage, { autoClose: 2000 });
    }
}


function* featureSaga() {
    yield takeEvery(GET_FEATURES, fetchFeatures)
    yield takeEvery(ADD_NEW_FEATURE, onAddNewFeature)
    yield takeEvery(UPDATE_FEATURE, onUpdateFeature)
    yield takeEvery(DELETE_FEATURE, onDeleteFeature)
}

export default featureSaga;